/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import * as web3Service from '../blockchain/web3.service'
import EventEmitter from "../Utils/EventEmitter"

export const useContractRefBonus = () => {

  const [totalRefBonus, setTotalRefBonus] = useState(0.00)
  const [isLoading, setLoading] = useState(false)

  const [logs, setLogs] = useState(null)

  useEffect(() => {
    const onNewLogs = (eventData) => {
      setLogs(eventData)
    }
    const listener = EventEmitter.addListener('HireDragonEvent', onNewLogs)
    return () => {
      listener.remove()
    }
  }, [])

  useEffect(async () => {

    try {
      setLoading(true)
      const totalRefBonusAmount = await web3Service.getTotalRefBonus()
      setTotalRefBonus(totalRefBonusAmount)
    } catch (error) {
      setTotalRefBonus(0.00)
      console.error('error while total bonus ref amount ', error)
    } finally {
      setLoading(false)
    }

  }, [logs])
  return { totalRefBonus, isLoading }
}

export default useContractRefBonus

